import { SOCKET_IO_URL } from "@ch/api";
import io from "socket.io-client";

export interface ChatSocket {
  emit: (
    type: string,
    payload: string,
    callback?: (data: string) => void,
  ) => void;
  on: (type: string, callback?: (data: string) => void) => void;
  close: () => void;
  connect: () => void;
  off: (type: string, callback?: (data: string) => void) => void;
  id: string;
}

const socket = io(`${SOCKET_IO_URL}/chats/1`, {
  transports: ["websocket", "polling"],
  reconnection: true,
  autoConnect: false, // Don't auto-connect, wait for explicit connect() call
}) as unknown as ChatSocket;

const chatSocket = socket;

export default chatSocket;
